class characterModel {
    constructor(myName, displayName, navActive, adminAccess, silohette, myBody){
        this.name = myName;      
        this.displayName = displayName;
        this.bodyComponent = myBody;
        this.silohette = silohette;
        this.navActive = navActive;
        this.adminAccess = adminAccess;
    }
}

export default characterModel;